import {
	cn,
	IconButton,
	MinusIcon,
	PlusIcon,
	TrashIcon,
} from "@au-schein-de/au-ui-library";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { getAmountInCartLabel } from "./cart.utils";

interface CartButtonsProps extends PropsWithChildren {
	quantity: number;
	canAddMore: boolean;
	isLoading: boolean;
	onAdd: (quantity: number) => void;
	onRemove: (quantity: number) => void;
	decrementStep: number;
	incrementStep: number;
	productCategory: string;
	productKind?: string | null;
	disabled: boolean;
}

export function CartButtons({
	quantity,
	canAddMore,
	decrementStep,
	incrementStep,
	onAdd,
	onRemove,
	productCategory,
	productKind,
	disabled,
}: CartButtonsProps) {
	const { t } = useTranslation();
	const showTrashIcon = quantity <= decrementStep;

	return (
		<div className="flex items-center gap-3 bg-gray-100 rounded-full py-1 px-1 h-fit w-38">
			<IconButton
				data-testid="cart-decrease-button"
				icon={showTrashIcon ? <TrashIcon.Raw /> : <MinusIcon.Raw />}
				shape="circle"
				className={cn(
					"bg-white",
					showTrashIcon ? "text-gray-700" : "text-ansay-main",
					disabled && "text-error-500",
				)}
				disabled={quantity === 0}
				onClick={() => onRemove(decrementStep)}
			/>
			<span
				className="w-full text-center text-body-bold text-gray-700"
				data-testid="cart-item-quantity"
			>
				{getAmountInCartLabel(t, quantity, productCategory, productKind)}
			</span>
			<IconButton
				data-testid="cart-increase-button"
				icon={<PlusIcon.Raw />}
				shape="circle"
				className={cn(
					"text-ansay-main bg-white",
					disabled && "bg-gray-200 text-gray-500",
				)}
				disabled={!canAddMore || disabled}
				onClick={() => onAdd(incrementStep)}
			/>
		</div>
	);
}
